import client from '../_helper/client'
import { stringify as querystring } from '../_helper/query'

export const entityService = {
    getAllEntities,
    getAllBuildings,
    getAllHomebases,
    getHomebase,
    editHomebase
}

function getAllEntities (organization) {
    return client.get(`/api/v2/tree/${organization}`)
}

function getAllBuildings (organization) {
    return client.get(`/api/v2/building/${organization}`)
}

function getAllHomebases (organization) {
    const query = querystring({
        organization: organization
    })
    return client.get(`/api/v2/homebase?${query}`)
}

function getHomebase (organization, homebase) {
    const query = querystring({
        organization: organization,
        homebase: homebase
    })
    return client.get(`/api/v2/homebase?${query}`)
}

function editHomebase (homebase, data) {
    const query = querystring({
        homebase: homebase
    })
    return client.put(`/api/v2/homebase?${query}`, data)
}
